// import $ from 'jquery';
import React from 'react';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import Field from './Field';
// import PropTypes from 'prop-types';

class FieldDatePicker extends Field {
    constructor(props) {
        super(props);
    }
    // format(value) {
    // }
    convertStringToMoment(value) {
        const { dateFormat } = this.props;

        if (value) {
            return moment(value, dateFormat);
        }

        return null;
    }
    generateProps() {
        const parentProps = super.generateProps();

        let props = {
            ...parentProps,
            ...this.props,
            className: 'field__input',
            showMonthDropdown: true,
            showYearDropdown: true,
            dropdownMode: 'select',
            onChange: (date) => this.onChange(date),
        };

        const { minDate, maxDate, selected, value } = props;

        if (minDate && typeof minDate != 'object') {
            props.minDate = this.convertStringToMoment(minDate);
        }
        if (maxDate && typeof maxDate != 'object') {
            props.maxDate = this.convertStringToMoment(maxDate);
        }
        if (!selected && value) {
            props.selected = this.convertStringToMoment(value);
        }

        return props;
    }
    onChange(date) {
        const { dateFormat, onChange } = this.props;
        const dateValue = date.format(dateFormat);

        if (onChange) {
            onChange(dateValue);
        }
    }
    validate() {
        const { value } = this.props;

        return (
            super.validate() &&
            /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[1,3-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/.test(
                value
            )
        );
    }
    render() {
        return (
            <div
                className={super.handleClasses()}
                data-label={super.renderAnimatedLabel()}
                ref={(r) => (this.field = r)}
            >
                {super.renderTooltip()}
                {super.renderLabel()}
                {super.renderAutoresize()}
                <DatePicker
                    ref={(r) => (this.input = r)}
                    {...this.generateProps()}
                />
                {super.renderError()}
                {super.renderLoading()}
            </div>
        );
    }
}
export default FieldDatePicker;
